module.exports = __webpack_public_path__ + "static/img/access-for-all__large.0a882c8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/CompanyTour/img/primary/access-for-all__large.jpg
// module id = WgLo
// module chunks = 1